<template>
  <div class="common-body admin-page-box">
    <!--<div class="admin-page-header common-separate-border-bottom"><slot name="header"></slot></div>-->
    <div class="admin-page-body">
      <slot></slot>
    </div>
    <div class="admin-page-footer common-separate-border-top">
      <page-footer
        :page-size="pageSize"
        :total="total"
        :current-page="currentPage"

        @size-change="onSizeChange"
        @current-change="onCurrentChange"
        @prev-click="onPrevClick"
        @next-click="onNextClick"
      ></page-footer></div>
  </div>
</template>

<script>
import PageHeader from './PageHeader'
import PageFooter from './PageFooter'
export default {
  name: 'PageBody',
  components: {
    PageHeader,
    PageFooter
  },
  data () {
    return {
      paging: {},
      refName: '',
      tableTop: 0
    }
  },
  props: {
    breadcrumbList: Array,
    total: Number,
    currentPage: {
      type: Number,
      default: 1
    },
    toolbar: {
      type: Boolean,
      default: true
    },
    openAdvancedSearch: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  methods: {
    onSizeChange (pageSize) { // 分页每页显示数据变化事件
      this.$emit('size-change', pageSize)
    },
    onCurrentChange (currentPage) { // 当前页码变动事件
      this.$emit('current-change', currentPage)
    },
    onPrevClick (currentPage) { // 上一页点击事件
      this.$emit('prev-click', currentPage)
    },
    onNextClick (currentPage) { // 下一页点击事件
      this.$emit('next-click', currentPage)
    }
  },
  watch: {
    total: {
      immediate: true,
      handler () {
        if (this.pageSize * (this.pageIndex -1 ) > this.total){
            if (this.pageIndex === 1){
              return
            }
            this.$emit('current-change', this.currentPage -1 )
        }
      }
    }
  },
  created () {
    this.refName = 'bar' + new Date().getTime()
  }
}
</script>

<style lang="scss" scoped>
  .admin-page-box{
    position: relative;
    background: white;
  }
  .admin-page-header{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: auto;
    height: 38px;
  }
  .admin-page-body{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 50px;
    background: #FFF;
  }
  .admin-page-footer{
    position: absolute;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    height: 48px;
    display: flex;
    align-items: center;
  }

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/Pages/PageBody.vue"
}
</vue-filename-injector>
